import { User } from "./user";

export interface Message {
  sid: string;
  sender: User;
  receiver: User;
  sentTimestamp: Date;
  receivedTimestamp?: Date;
  content: string;
  status: StatusValues;
  media?: MediaItem[];
}

export interface FetchSMSRequest {
  to?: string;
  from_?: string;
  date_sent_after?: Date;
  date_sent_before?: Date;
  limit?: number;
  page_size?: number;
  page_token?: string;
}

export interface StatusUpdate {
  To: string;
  MessageSid: string;
  MessageStatus: string;
}

export interface Status {
  sid: string;
  status: StatusValues;
}

export enum StatusValues {
  QUEUED = 'queued',
  SENDING = 'sending',
  SENT = 'sent',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  UNDELIVERED = 'undelivered',
  ACCEPTED = 'accepted',
  SCHEDULED = 'scheduled',
  CANCELED = 'canceled',
  RECEIVED = 'received',
  RECEIVING = 'receiving'
}

export interface MessageRequest {
  sender: User;
  receiver: User;
  content: string;
  media_urls?: string[];
}

export interface MessageResponse {
  messageDetails: MessageDetails;
  statusCode: string;
}

export interface MessageDetails {
  body: string;
  date_created: Date;
  date_sent: Date;
  date_updated: Date;
  direction: string;
  error_code: string;
  error_message: string;
  from_: string;
  num_media: number;
  num_segments: number;
  sid: string;
  status: string;
  to: string;
}

export interface IncomingMessage {
  MessageSid: string;
  SmsSid: string;
  SmsMessageSid: string;
  AccountSid: string;
  MessagingServiceSid: string;
  From: string;
  To: string;
  Body: string;
  NumMedia: string;
  NumSegments: string;
  Media?: MediaItem[];
}

export interface MediaItem {
  url: string;
  filename: string;
  contentType: string;
  size: number;
}

export interface MediaTypeDefinition {
  mime: string;
  extension: string;
  category: 'image' | 'video' | 'audio' | 'document' | 'other';
}

export const SUPPORTED_MEDIA: MediaTypeDefinition[] = [
  { mime: 'image/jpeg', extension: '.jpeg', category: 'image' },
  { mime: 'image/png', extension: '.png', category: 'image' },
  { mime: 'image/gif', extension: '.gif', category: 'image' },
  { mime: 'application/pdf', extension: '.pdf', category: 'document' },
  { mime: 'application/rtf', extension: '.rtf', category: 'document' },
];

export interface HistoryApiMessage {
  sid: string;
  sender: string;
  receiver: string;
  senttimestamp?: string;
  datecreated: string;
  receivedtimestamp?: string;
  content: string;
  status: string;
  media?: string; // JSON string of media URLs
}